// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centered-input[data-v-0cefba29] input{text-align:center}", ""]);
// Exports
module.exports = exports;
